'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-next-line react/prop-types
var UnderlineMark = function UnderlineMark(_ref) {
  var children = _ref.children;
  return _react2.default.createElement(
    'u',
    null,
    children
  );
};

exports.default = UnderlineMark;